import { FC, ReactElement, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { ReactComponent as MoneyIcon } from '../../assets/icons/money2.svg'
import { RoutesEnum } from '../../utils/routesEnum'
import TabItems from '../loggedArea/tabItems'
import Plans from './plans'
import StatementContainer from './statement'
import { Container } from './style'

type SubscriptionProps = {
  type: 'plans' | 'statement'
}

const Subscription: FC<SubscriptionProps> = ({ type }): ReactElement => {
  const history = useHistory()

  const activeItem = useCallback(() => {
    if (history.location.pathname === RoutesEnum.SUBSCRIPTION) return 0
    if (history.location.pathname === RoutesEnum.SUBSCRIPTION_STATEMENT) return 1

    return 0
  }, [history])

  const onTabChange = useCallback((index: number) => {
    if (index === 0) history.push(RoutesEnum.SUBSCRIPTION)
    if (index === 1) history.push(RoutesEnum.SUBSCRIPTION_STATEMENT)
  }, [history])

  return (
    <TabItems
      breadcrumbs={[
        { title: 'Assinatura', to: RoutesEnum.SUBSCRIPTION },
        { title: 'Minha assinatura', to: RoutesEnum.SUBSCRIPTION },
        ...(activeItem() === 1 ? [{ title: 'Extrato', to: RoutesEnum.SUBSCRIPTION_STATEMENT }] : [])
      ]}
      items={[
        { name: 'Assinatura', icon: <MoneyIcon /> },
        { name: 'Extrato', icon: <MoneyIcon /> }
      ]}
      activeItem={activeItem()}
      onChangeTab={onTabChange}
      title='Assinatura'
      subtitle='Altere seu plano e verifique seus pagamentos'
    >
      <Container>
        {type === 'plans' && <Plans />}
        {type === 'statement' && <StatementContainer />}
      </Container>
    </TabItems>
  )
}

export default Subscription
